import { initialState } from '..'
import { FLAG_FEATURE_ENABLED, GlobalActions } from '../../actions/global/global'

export type GlobalStoreType = {
  features: {
    [feature: string]: boolean
  }
}

const reducer = (state: GlobalStoreType = initialState.global, { type, payload }: GlobalActions): GlobalStoreType => {
  switch (type) {
    case FLAG_FEATURE_ENABLED:
      return {
        ...state,
        features: {
          ...state.features,
          [payload.feature]: true,
        },
      }

    default:
      return state
  }
}

export default reducer
